<template>
    <div class="english-container">
  
      <h2>Elk product kan slechts met één apparaat worden gekoppeld.</h2>
      <h2>IOS:</h2>
      <h1>Snelstart</h1>
      

  
      <ol>
        <li>Schakel de smartcard in.</li>
        <li>Open de app “Find My” en tik op “+”.</li>
        <li>Selecteer “Voeg ander item toe”.</li>
        <li>Tik op “Verbinden”.</li>
        <li>Volg de instructies op het scherm om de verbinding te voltooien.</li>
      </ol>
  
      <div class="divider"></div>
  
      <h2>Zoek Uw Item <span>03</span></h2>
  
      <h3>1. Item Locator vinden wanneer deze dichtbij is</h3>
  
      <p>
        Open de Find My-app en selecteer het tabblad “Items”.
        Tik op uw Item Locator in de lijst.
        Tik op “Geluid afspelen” om uw Item Locator een geluid te laten maken.
        Tik op “Geluid stoppen” zodra u uw item hebt gevonden.
      </p>
  
      <h3>2. Laatst bekende locatie van Item Locator vinden</h3>
  
      <p>
        Open de Find My-app en selecteer het tabblad “Items”.
        Tik op uw Item Locator in de lijst.
        De laatst bekende locatie van uw Item Locator wordt op de kaart weergegeven.
      </p>
  
      <div class="divider"></div>
  
      <h2>Item vinden buiten bereik <span>04</span></h2>
  
      <h3>1. “Waarschuwen wanneer achtergelaten” inschakelen</h3>
  
      <p>
        Open de Find My-app en selecteer het tabblad “Items”.
        Tik op uw Item Locator in de lijst.
        Schakel onder “Meldingen” de optie
        “Waarschuwen wanneer achtergelaten” in.
      </p>
  
      <h3>2. “Melden wanneer gevonden” inschakelen</h3>
  
      <p>
        Schakel onder Meldingen de optie
        “Melden wanneer gevonden” in.
        Wanneer uw item wordt gezien door een ander apparaat
        met Find My-functionaliteit, ontvangt u een melding
        van de bijgewerkte locatie.
      </p>
  
      <div class="divider"></div>
  
      <h2>Wanneer uw item verloren is <span>05</span></h2>
  
      <p>
        Open de Find My-app en selecteer het tabblad “Items”.
        Tik op uw Item Locator in de lijst.
      </p>
  
      <p>
        Tik onder Verloren-modus op “Inschakelen”.
        Er verschijnt een scherm met details over Verloren-modus.
        Tik op “Doorgaan” en voer uw telefoonnummer of e-mailadres in.
      </p>
  
      <div class="divider"></div>
  
      <h2>Uw Item Locator resetten <span>06</span></h2>
  
      <h3>1. Verwijder de Item Locator uit Find My</h3>
  
      <p>
        Open de Find My-app en selecteer het tabblad “Items”.
        Tik op uw Item Locator in de lijst.
        Zorg ervoor dat “Verloren-modus” is uitgeschakeld.
        Scroll naar beneden en tik op “Item verwijderen”.
      </p>
  
      <h3>2. Fabrieksinstellingen herstellen</h3>
  
      <p>
        Nadat u de Item Locator succesvol uit Find My hebt verwijderd,
        drukt u vier keer snel op de functietoets en houdt u deze
        vervolgens een vijfde keer ingedrukt totdat u een beltoon hoort.
      </p>
  
      <div class="divider"></div>
  
      <h2>Maar wacht... Er is meer <span>07</span></h2>
  
      <h3>1. Opladen</h3>
  
      <p>
        Gebruik standaard draadloze opladers om het product draadloos op te laden.
        Het rode lampje brandt tijdens het opladen
        en gaat uit zodra het product volledig is opgeladen.
      </p>
  
      <h3>2. Detectie van ongewenste tracking</h3>
  
      <p>
        Als uw telefoon een onbekende Item Locator detecteert
        die met u meebeweegt, ontvangt u hiervan een melding.
      </p>
  
      <div class="divider"></div>
  
      <h2>Belangrijke informatie</h2>
  
      <p class="small">
        Dit apparaat voldoet aan Deel 15 van de FCC-regels.
        Het gebruik is onderworpen aan de volgende twee voorwaarden:
      </p>
  
      <ol class="small">
        <li>Dit apparaat mag geen schadelijke storing veroorzaken.</li>
        <li>
          Dit apparaat moet alle ontvangen storingen accepteren,
          inclusief storingen die ongewenste werking kunnen veroorzaken.
        </li>
      </ol>
  
      <p class="small">
        OPMERKING:
        De fabrikant is niet verantwoordelijk voor radio- of tv-storingen
        veroorzaakt door ongeautoriseerde wijzigingen aan dit apparaat.
        Dergelijke wijzigingen kunnen het recht van de gebruiker
        om het apparaat te bedienen ongeldig maken.
      </p>
  
      <p class="small">
        Deze apparatuur is getest op naleving van de algemene RF-blootstellingsvereisten.
        Het apparaat kan zonder beperkingen onder draagbare omstandigheden worden gebruikt.
      </p>
  
      <p class="small">
        Deze apparatuur is getest en voldoet aan de limieten
        voor een Klasse B digitaal apparaat volgens Deel 15 van de FCC-regels.
      </p>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'CardDutchLanguage',
  };
  </script>
  
  <style scoped>
  
  .english-container{
    background-color:#ffffff;
    border-radius:8px;
    padding:30px;
    margin:10px auto;
    max-width:1000px;
    box-shadow:0 2px 8px rgba(0,0,0,0.08);
  }
  
  h1{
    font-size:42px;
    margin-bottom:25px;
    color:#222;
    text-align:left;
  }
  
  h2{
    font-size:28px;
    margin-top:35px;
    margin-bottom:15px;
    color:#222;
    text-align:left;
  }
  
  h3{
    font-size:20px;
    margin-top:24px;
    margin-bottom:10px;
    color:#333;
    text-align:left;
  }
  
  p{
    font-size:15px;
    line-height:1.8;
    color:#333;
    text-align:left;
    margin-bottom:14px;
  }
  
  ol{
    padding-left:24px;
    margin-bottom:20px;
  }
  
  li{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:10px;
    text-align:left;
  }
  
  .small{
    font-size:13px;
    line-height:1.7;
  }
  
  .divider{
    width:100%;
    height:1px;
    background:#e5e5e5;
    margin:40px 0;
  }
  
  span{
    color:#888;
    font-weight:700;
  }
  
  .image_1{
    width:90%;
    max-width:600px;
    height:auto;
    margin:20px auto;
    display:block;
    border-radius:8px;
  }
  
  @media (max-width:768px){
  
    .english-container{
      padding:20px;
    }
  
    h1{
      font-size:32px;
    }
  
    h2{
      font-size:24px;
    }
  
    h3{
      font-size:18px;
    }
  
    p, li{
      font-size:14px;
    }
  }
  
  </style>